import React, { Component } from 'react'
import PropTypes from 'prop-types'

import axios from 'axios'

import HeaderPage from './../block/HeaderPage'
import Breadcrumbs from './../block/Breadcrumbs'
import ShopsNg from './../block/ShopsNg'
import QwestionsNg from './../block/QwestionsNg'
import Lists from './../block/ListsProductPage'

import { Container, Image, Button } from 'react-bootstrap'

import styles from './../blocks.module.sass'

export default class Main extends Component {

  constructor(props) {
    super(props)

    this.state = {
      recomended: []
    }
  }

  loadRecomended = () => {
    const baseURL = window.location.protocol + "//" + window.location.hostname,
    main = this

    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'load_products_ng',
      'variant': `rend`,
      'page': 1
    }).then( ( response ) => {
      main.setState({
        recomended: response.data.products
      })
    })
  }

  componentDidMount() {
    const { ajax_data } = this.props
    if( ajax_data.yookassa_url != '' ) window.location.href = ajax_data.yookassa_url
    this.loadRecomended()
  }

  render() {

    const { ajax_data, page_data, changeTopSearch, changeLeftMenuh, showInCart, favorite, changeFavorite, cart, in_cart_loading } = this.props,
    { recomended } = this.state

    return (
      <>
        <div className='w-100' style={{ flex: 1 }}>
          <HeaderPage
            ajax_data={ajax_data}
            page_data={page_data}
            changeTopSearch={changeTopSearch}
            changeLeftMenuh={changeLeftMenuh}
            favorite={favorite}
            cart={cart}
          />
          {ajax_data != null &&
            <>
              <Breadcrumbs
                pages={[
                  {
                    name: `Корзина`,
                    url: page_data.cart_link,
                    current: false
                  },
                  {
                    name: `Оформление заказа`,
                    current: true
                  }
                ]}
              />
              <div className={styles.oformlen_page}>
                <Container>
                  {ajax_data.image &&
                    <Image className='d-none d-md-block' src={ajax_data.image} />
                  }
                  {ajax_data.image_mob &&
                    <Image className='d-md-none' src={ajax_data.image_mob} />
                  }
                  <h1>{ajax_data.seo_h1}</h1>
                  {ajax_data.order != null ?
                    <> 
                      <div className={styles.oformlen_page_str}>Поздравляем! Вы успешно оформили заказ</div>
                      <div className={styles.oformlen_page_str}>Спасибо, что доверяете свой комфорт и стиль <span>BRUNO ALTRO</span></div>
                      <div className={styles.oformlen_page_ostr}>Номер вашего заказа № {ajax_data.order}</div>
                    </>
                  :
                    <>
                      <div className={styles.oformlen_page_ostr}>Заказ с таким номером не найден!</div>
                    </>
                  }
                  <div className='w-100 d-flex justify-content-center'>
                    {ajax_data.yookassa_url != '' ?
                      <Button href={ajax_data.yookassa_url} className={styles.oformlen_page_ostr_btn} variant='dark'>Перейти к оплате</Button>
                    :
                      <>
                        {ajax_data.dolyame_link != '' ?
                          <Button href={ajax_data.dolyame_link} className={styles.oformlen_page_ostr_btn} variant='dark'>Перейти к оплате</Button>
                        :
                          <Button href={'/'} className={styles.oformlen_page_ostr_btn} variant='dark'>На главную</Button>
                        }
                      </>
                    }
                  </div>
                  <div className={styles.oformlen_page_ostr}>Обработка заказа начнется сразу после того, как мы подтвердим получение оплаты. Обычно это происходит в течение нескольких минут после совершения платежа.</div>
                </Container>
              </div>
            </>
          }
          <Lists
            title={`ТАКЖЕ РЕКОМЕНДУЕМ`}
            products={recomended}
            showInCart={showInCart}
            in_cart_loading={in_cart_loading}
            favorite={favorite}
            changeFavorite={changeFavorite}
            cart={cart}
            link={page_data.man_link}
          />
          <ShopsNg
            page_data={page_data}
            ajax_data={ajax_data}
          />
          <QwestionsNg
            ajax_data={ajax_data}
          />
        </div>
      </>
    )
  }
}

Main.propTypes = {
  ajax_data: PropTypes.object,
  page_data: PropTypes.object,
  search: PropTypes.string,
  changeSearch: PropTypes.func,
  changeTopSearch: PropTypes.func,
  changeLeftMenuh: PropTypes.func,
  showInCart: PropTypes.func,
  favorite: PropTypes.array,
  changeFavorite: PropTypes.func,
  cart: PropTypes.array,
  in_cart_loading: PropTypes.bool
}